// Date
import { format, addDays } from 'date-fns';

export function today() {
  return new Date();
}

export function todayString() {
  return format(new Date(), 'yyyy-MM-dd');
}

export function addDaysToDateString(dateString, days) {
  const date = new Date(dateString);
  return format(addDays(date, days), 'yyyy-MM-dd');
}


export const datePlusDays = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10); // YYYY-MM-DD
};
